var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_18209)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "has-stroke",
    d: "M39.1865 36.0387V16.6666C39.1865 16.2852 39.035 15.9194 38.7653 15.6497C38.4956 15.38 38.1299 15.2285 37.7485 15.2285H28.9579C28.5765 15.2285 28.2107 15.38 27.941 15.6497C27.6713 15.9194 27.5198 16.2852 27.5198 16.6666V36.0618C27.5198 36.4432 27.6713 36.809 27.941 37.0787C28.2107 37.3484 28.5765 37.4999 28.9579 37.4999H37.7253C37.9172 37.4999 38.1072 37.4621 38.2845 37.3887C38.4617 37.3152 38.6228 37.2076 38.7585 37.0719C38.8942 36.9362 39.0018 36.7751 39.0753 36.5978C39.1487 36.4206 39.1865 36.2306 39.1865 36.0387Z",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "has-fill",
    d: "M33.3534 35.8327C33.8136 35.8327 34.1867 35.4596 34.1867 34.9993C34.1867 34.5391 33.8136 34.166 33.3534 34.166C32.8931 34.166 32.52 34.5391 32.52 34.9993C32.52 35.4596 32.8931 35.8327 33.3534 35.8327Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    className: "has-stroke",
    d: "M25 28.334H2.49998C2.05795 28.334 1.63403 28.1584 1.32147 27.8458C1.00891 27.5333 0.833313 27.1093 0.833313 26.6673V3.75065C0.833313 3.30862 1.00891 2.8847 1.32147 2.57214C1.63403 2.25958 2.05795 2.08398 2.49998 2.08398H34.1666C34.6087 2.08398 35.0326 2.25958 35.3452 2.57214C35.6577 2.8847 35.8333 3.30862 35.8333 3.75065V12.5007",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "has-stroke",
    d: "M0.833313 23.334H25",
    stroke: "#696969",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "has-fill",
    d: "M18.3333 26.6667C18.7936 26.6667 19.1667 26.2936 19.1667 25.8333C19.1667 25.3731 18.7936 25 18.3333 25C17.8731 25 17.5 25.3731 17.5 25.8333C17.5 26.2936 17.8731 26.6667 18.3333 26.6667Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    className: "has-stroke",
    d: "M15.8333 28.334L15 34.1673",
    stroke: "#696969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "has-stroke",
    d: "M21.6667 28.334L22.5 34.1673",
    stroke: "#696969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "has-stroke",
    d: "M24.5834 34.168H12.9167",
    stroke: "#696969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_18209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerMobileIcon);
export default __webpack_public_path__ + "static/media/computer_mobile_icon.6c233a598e0c67927027947195b4358c.svg";
export { ForwardRef as ReactComponent };